import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "watchMore",
    value:
    // 浏览更多
    function watchMore(id) {
      this.$router.push("/classify?parentTypeId=".concat(id));
    }
  }, {
    key: "goDetails",
    value: function goDetails(id) {
      this.$router.push("/details?id=".concat(id, "&from=hotlist"));
    }
  }]);
}(Vue);
__decorate([Prop({
  default: []
})], default_1.prototype, "recommendList", void 0);
default_1 = __decorate([Component({
  components: {
    Price: Price
  }
})], default_1);
export default default_1;